import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core"

@Component({
	selector: "app-modal-multi-building",
	templateUrl: "./modal-multi-building.component.html",
	styleUrls: ["./modal-multi-building.component.scss"]
})
export class ModalMultiBuildingComponent implements OnChanges {
	@Input() buildings: any[]
	@Input() end: any
	@Output() selectBuilding: EventEmitter<any> = new EventEmitter()
	@Output() dismissModal: EventEmitter<any> = new EventEmitter()
	public wait = true

	ngOnChanges(changes) {
		if (changes && changes.buildings) {
			this.wait = this.buildings.length ? false : true
		}
	}
}
